var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3279 3.04374C10.9044 2.44875 10.8893 1.49912 10.2944 0.922681C9.69937 0.346242 8.74974 0.361278 8.1733 0.956264L10.3279 3.04374ZM1.5 10L0.422681 8.95626C-0.140894 9.53797 -0.140894 10.462 0.422681 11.0437L1.5 10ZM8.1733 19.0437C8.74974 19.6387 9.69937 19.6538 10.2944 19.0773C10.8893 18.5009 10.9044 17.5513 10.3279 16.9563L8.1733 19.0437ZM8.1733 0.956264L0.422681 8.95626L2.57732 11.0437L10.3279 3.04374L8.1733 0.956264ZM0.422681 11.0437L8.1733 19.0437L10.3279 16.9563L2.57732 8.95626L0.422681 11.0437Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.077cce0de261d383d81b417104954ef9.svg";
export { ForwardRef as ReactComponent };